import { render } from "./EnbContent.vue?vue&type=template&id=2ec2a0b4&scoped=true"
import script from "./EnbContent.vue?vue&type=script&lang=js"
export * from "./EnbContent.vue?vue&type=script&lang=js"

import "./EnbContent.vue?vue&type=style&index=0&id=2ec2a0b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec2a0b4"]])

export default __exports__